/** Represents the commit details (title and description) generated by Copilot. */
export interface ICopilotCommitMessage {
  readonly title: string
  readonly description: string
}

function isRecord(value: unknown): value is Readonly<Record<string, unknown>> {
  return typeof value === 'object' && value !== null && !Array.isArray(value)
}

export function parseCopilotCommitMessage(
  content: string
): ICopilotCommitMessage {
  const jsonMatch =
    content.match(/```json\s*([\s\S]*?)```/) ||
    content.match(/```\s*([\s\S]*?)```/)
  const jsonStr = jsonMatch ? jsonMatch[1].trim() : content.trim()

  let parsed: unknown
  try {
    parsed = JSON.parse(jsonStr)
  } catch {
    throw new Error(
      'Copilot returned invalid JSON for commit message generation'
    )
  }

  if (!isRecord(parsed)) {
    throw new Error(
      'Copilot returned an invalid commit message payload: expected an object'
    )
  }

  const title = parsed.title
  if (typeof title !== 'string' || title.trim().length === 0) {
    throw new Error(
      'Copilot returned an invalid commit message payload: "title" must be a non-empty string'
    )
  }

  const description = parsed.description
  if (description === undefined) {
    return {
      title,
      description: '',
    }
  }

  if (typeof description !== 'string') {
    throw new Error(
      'Copilot returned an invalid commit message payload: "description" must be a string when provided'
    )
  }

  return {
    title,
    description,
  }
}
